import * as React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import withStyles from '@material-ui/core/styles/withStyles'
import GoogleIcon from 'components/icons/Google'
import Button from 'components/Button'

export const styles = (theme) => ({
  root: {
    backgroundColor: '#fff',
    color: '#000',
    '&:hover': {
      backgroundColor: '#fff',
    },
    '&[disabled]': {
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.action.disabled,
    },
  },
})

const GoogleButton = React.forwardRef(function GoogleButton(props, ref) {
  const { children, classes, className, ...other } = props

  return (
    <Button
      className={clsx(classes.root, className)}
      startIcon={<GoogleIcon />}
      ref={ref}
      id="googleButtonDiv"
      {...other}
    >
      {children}
    </Button>
  )
})

GoogleButton.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
}

export default withStyles(styles)(GoogleButton)
